import { render } from "./InputTimeFrameUnit.vue?vue&type=template&id=2458a653"
import script from "./InputTimeFrameUnit.vue?vue&type=script&lang=js"
export * from "./InputTimeFrameUnit.vue?vue&type=script&lang=js"
script.render = render

export default script